// ABOUTME: Pure sky values for the breathing round: storm, overcast, rain and cloud opacities from the round's progress.
// ABOUTME: x is the fraction of the round that has passed, and 1 (the cleared sky) when no round is armed.

export interface BreathSky {
  stormOp: number;
  overcastOp: number;
  rainOp: number;
  rainRotDeg: number;
  rainDurSec: number;
  rainRunning: boolean;
  cloudInk: 'dark' | 'light';
  cloud1Op: number;
  cloud2Op: number;
  cloud3Op: number;
}

const clamp01 = (value: number) => Math.min(1, Math.max(0, value));

export function roundProgress(armed: boolean, total: number, leftSec: number): number {
  return armed && total > 0 ? clamp01(1 - leftSec / total) : 1;
}

export function breathSkyAt(x: number, armed: boolean): BreathSky {
  const ramp = (from: number, to: number) => clamp01((x - from) / (to - from));
  return {
    stormOp: 1 - ramp(0.25, 0.5),
    overcastOp: 1 - ramp(0.5, 0.75),
    rainOp: armed ? 0.85 * (1 - ramp(0.19, 0.25)) : 0,
    // Written this way so it is exactly 0 (never -0) from x = 0.25.
    rainRotDeg: 30 * ramp(0, 0.25) - 30,
    rainDurSec: 0.9 + 1.8 * ramp(0, 0.25),
    rainRunning: armed && x < 0.25,
    cloudInk: x < 0.5 ? 'dark' : 'light',
    cloud1Op: 1 - ramp(0.5, 0.625),
    cloud2Op: 1 - ramp(0.75, 0.833),
    cloud3Op: 1 - ramp(0.75, 0.81),
  };
}
